/**
 * MSPDI 匯入的 fail-closed 判準（純函式，兩個宿主共用）。
 *
 * core 遇到「不是 MSPDI 的檔案」不是丟例外，而是回傳空白專案 + Error 級診斷。
 * 直接載入等於把使用者目前的專案靜靜換成空白，所以 desktop 與 browser 都在
 * 載入前先擋一次；判準放同一個地方，避免兩邊政策長歪。
 */

import type { MspdiImportResult } from '@bigint-project/core';

export function assertMspdiImportable(result: MspdiImportResult): void {
  const blockers = result.diagnostics.filter((diagnostic) => diagnostic.severity === 'Error');
  if (blockers.length === 0) return;
  throw new Error(blockers.map((diagnostic) => diagnostic.message).join('\n'));
}
